import PRIVILEGE from '../core/constants/privilege';

export default {
  security: [
    {
      id: 'securityOverview',
      system: 'CRM',
      url: '/security/securityOverview'
    },
    {
      id: 'securityLogs',
      system: 'CRM',
      url: '/security/securityLogs',
    },
    {
      id: 'securityNoticeConfig',
      system: 'CRM',
      url: '/security/noticeConfig',
    },
    {
      id: 'loginLogs',
      system: 'CRM',
      url: '/security/loginLogs',
    },
    {
      id: 'securityGuide',
      system: 'CRM',
      url: '/security/securityGuide',
    },
  ],
};
